{
    "cancel": "Annuler",
    "confirm": "Confirmer",
    "save": "Enregistrer",
    "delete": "Supprimer",
    "edit": "Modifier",
    "back": "Retour",
    "next": "Suivant",
    "previous": "Précédent",
    "search": "Rechercher",
    "loading": "Chargement...",
    "submit": "Soumettre",
    "close": "Fermer",
    "yes": "Oui",
    "no": "Non",
    "login": "Connexion",
    "logout": "Déconnexion",
    "register": "S'inscrire",
    "email": "E-mail",
    "password": "Mot de passe",
    "phone": "Numéro de téléphone",
    "settings": "Paramètres",
    "profile": "Profil",
    "dashboard": "Tableau de bord",
    "actions": "Actions",
    "status": "Statut",
    "createdAt": "Date de création",
    "updatedAt": "Date de modification",
    "cookie": {
        "banner": {
            "title": "Nous utilisons des cookies",
            "message": "Nous utilisons des cookies pour améliorer votre expérience et analyser le trafic.",
            "accept": "Tout accepter",
            "reject": "Essentiels uniquement",
            "manage": "Gérer les préférences",
            "learnMore": "En savoir plus"
        }
    }
}
